// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"083cc237","490":"452b4795","616":"474a4b8d","771":"aee1d426","928":"2961f461","971":"0929ec8b"}[chunkId] + ".chunk.js";
};